export const showGrid       = false;
export const frameSize      = [13, 13];
export const centerOnPlayer = true;

export const flashlight = `

         ..
        ....
       .....
      ......
     .......
    ........
    .@......
    ........
     .......
      ......
       .....
        ....
         ..

`;

export const realityMap = `
#########################################################
#                                                       #
#                                                       #
#                                                       #
#                                                       #
#           #####         #####         #####           #
#    #####         #####         #####         #####    #
#    #   #                                     #   #    #
#    #   #                  @                  #   #    #
#    #   #                                     #   #    #
#    #####         #####         #####         #####    #
#           #####         #####         #####           #
#                                                       #
#                                                       #
#                                                       #
#                                                       #
#########################################################
`;



/** WEBPACK FOOTER **
 ** ./src/config.es6.js
 **/